/**
 * Writes setup-revision lines to the shared web log, so no call site has to
 * know the source name or which level a failure belongs at.
 */

import { webLog } from '../../api/grpc/webLogger';
import {
  formatSetupRevisionLog,
  type SetupRevisionLogEvent,
  type SetupRevisionLogFields,
} from './revisionLog';

/** The single source name every setup-revision line is captured under. */
export const SetupRevisionLogSource = 'setupRevision';

export const logSetupRevision = (
  event: SetupRevisionLogEvent,
  fields: SetupRevisionLogFields
): void => {
  const line = formatSetupRevisionLog(event, fields);

  if (event === 'revisionFailed') {
    webLog.warn(SetupRevisionLogSource, line);
    return;
  }

  webLog.info(SetupRevisionLogSource, line);
};
